import type { RouteObject } from "react-router-dom";

export const warehouseSlasRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Warehouse SLAs" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { WarehouseSlasPage } = await import("./warehouse-slas-page");
          return { Component: WarehouseSlasPage };
        },
      },
    ],
  },
];
